<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('services')"
      :columns="columns"
      :column_search="true"
      :extra_data="{ bag_uuid: bag_uuid }"
      resource_url="/timebag/service/datatables"
      :page_length="50"
    >
      <template v-slot:buttons>
        <!-- <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button> -->
      </template>
    </generic-table>
  </div>
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  format_date,
  error_message,
  format_currency,
} from "@/utils";

export default {
  name: "TimebagDatatable",
  components: { GenericTable },
  // props: {
  //   bag_uuid: {
  //     type: String,
  //     required: true,
  //   },
  // },
  data() {
    let v = this;
    return {
      bag_uuid: null,
      columns: [
        {
          title: v.$t("date"),
          searchable: true,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `${format_date(row.date)} (${row.number_of_hours}h)`;
          },
        },
        {
          title: v.$t("description"),
          searchable: true,
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.description || "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.number || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$emit("edit_service", e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete service?"),
                    v,
                    () => {
                      del("/timebag/service", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.timebag_modal.edit_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete timebag?"),
        v,
        () => {
          put("/timebag/service", {})
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    set_initial_state() {
      let v = this;
      v.$refs.datatable.destroy();
    },
    init(bag_uuid) {
      let v = this;
      v.bag_uuid = bag_uuid;
      v.set_initial_state();
      v.refresh();
    },
  },
  mounted() {},
};
</script>

<style></style>
